import type { PayloadAction } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';
import {
  clearExpandedCategories,
  collapseCategory,
  expandCategory,
  selectCustomerOutcome,
  setCustomerFilter,
  setOutcomeFilter,
  setPlatformFilter,
  setStateFilter,
} from 'actions/useCasePage';

export type ModelState = {
  stateFilter: string;
  customerFilter: string;
  platformFilter: string;
  outcomeFilter: string;
  expandedCategories: string[];
  selectedCustomerOutcome: string;
};
type UseCasePageReducer<P = void> = (state: ModelState, action: PayloadAction<P>) => ModelState;

const defaultState: ModelState = {
  stateFilter: '',
  customerFilter: '',
  platformFilter: '',
  outcomeFilter: '',
  expandedCategories: [],
  selectedCustomerOutcome: '',
};

const handleSetStateFilter: UseCasePageReducer<string> = (state, { payload }) => ({
  ...state,
  stateFilter: payload,
});

const handleSetCustomerFilter: UseCasePageReducer<string> = (state, { payload }) => ({
  ...state,
  customerFilter: payload,
});

const handleSetPlatformFilter: UseCasePageReducer<string> = (state, { payload }) => ({
  ...state,
  platformFilter: payload,
});

const handleSetOutcomeFilter: UseCasePageReducer<string> = (state, { payload }) => ({
  ...state,
  outcomeFilter: payload,
});

const handleExpandCategory: UseCasePageReducer<string> = (state, { payload }) => ({
  ...state,
  expandedCategories: [...state.expandedCategories, payload],
});

const handleCollapseCategory: UseCasePageReducer<string> = (state, { payload }) => ({
  ...state,
  expandedCategories: state.expandedCategories.filter((c) => c !== payload),
});

const handleClearExpandedCategories: UseCasePageReducer = (state) => ({
  ...state,
  expandedCategories: [],
});

const handleSelectCustomerOutcome: UseCasePageReducer<string> = (state, { payload }) => ({
  ...state,
  selectedCustomerOutcome: payload,
});

const handlers = {
  [setStateFilter.toString()]: handleSetStateFilter,
  [setCustomerFilter.toString()]: handleSetCustomerFilter,
  [setPlatformFilter.toString()]: handleSetPlatformFilter,
  [setOutcomeFilter.toString()]: handleSetOutcomeFilter,

  [expandCategory.toString()]: handleExpandCategory,
  [collapseCategory.toString()]: handleCollapseCategory,
  [clearExpandedCategories.toString()]: handleClearExpandedCategories,
  [selectCustomerOutcome.toString()]: handleSelectCustomerOutcome,
};

const modelsReducer = createReducer(defaultState, handlers);

export default modelsReducer;
